export const COLUMNS_HEADERS = {
  reference_number: { sortable: true },
  inUse: { sortable: false },
  project: { sortable: false },
  location: { sortable: false },
};
